import {
  ChangeDetectionStrategy, Component, createNgModule, OnInit, ViewChild, ViewContainerRef,
  Injector,
  ComponentRef,
  Input, OnChanges, 
  
  
} from '@angular/core';



import type { BudgetInfoComponent as OriginalComponent } from '../../components/budget-info/budget-info.component';

@Component({
  selector: 'ish-lazy-budget-info',
  templateUrl: './lazy-budget-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LazyBudgetInfoComponent implements OnInit , OnChanges {
  /*
   * WARNING!
   *
   * This file was automatically generated!
   * It should be updated using:
   *
   * ng g lazy-component components/budget-info/budget-info.component.ts
   *
   */

  @ViewChild('anchor', { read: ViewContainerRef, static: true }) anchor: ViewContainerRef;


  @Input() suffix: OriginalComponent['suffix'];

  @Input() placement: OriginalComponent['placement'];


  private component: ComponentRef<OriginalComponent>;
  

  constructor(
    
    private injector: Injector
  ) {}

  async ngOnInit() {
    

      await this.renderComponent();

    
  }

  private async renderComponent() {
    const module = await import(`../../organization-management.module`).then(m => m.OrganizationManagementModule);

    const { BudgetInfoComponent: originalComponent } = await import('../../components/budget-info/budget-info.component');

    const ngModuleRef = createNgModule(module, this.injector);

    this.component = this.anchor.createComponent(originalComponent, { ngModuleRef });
  
    this.ngOnChanges(
      
    );
  
    this.component.changeDetectorRef.markForCheck();
  }


  ngOnChanges() {
    if (this.component) {
      
        this.component.instance.suffix = this.suffix;
      
        this.component.instance.placement = this.placement;
      

      
    }
  }

}
